import type { Root } from 'mdast';
import type { Plugin } from 'unified';
// type-only import so that the "micromarkExtensions" augmentation of the unified data is picked up
import type {} from 'remark-parse';

// Markdown constructs that the HtmlEditor cannot create. Users regularly type these characters as
// plain text (e.g. "> " to mark the lines of a list), and the editor keeps them literal, so the
// renderer must not turn them into formatting either.
const unsupportedConstructs = [
  // "<https://example.com>"
  'autolink',
  // "&amp;"
  'characterReference',
  // "> quote"
  'blockQuote',
  // "`code`", "```code```" and code indented by four spaces
  'codeFenced',
  'codeIndented',
  'codeText',
  // "[label]: https://example.com", which would be dropped from the output entirely
  'definition',
  // "# heading" and a heading underlined with "===" or "---"
  'headingAtx',
  'setextUnderline',
  // "<div>html</div>" and "<b>html</b>"; those are not rendered anyway, but without the flow
  // variant the text ends up outside of a paragraph
  'htmlFlow',
  'htmlText',
  // "---"
  'thematicBreak',
];

/**
 * Restricts the markdown syntax to what the HtmlEditor supports by disabling the micromark
 * constructs of all unsupported elements, which leaves their markers as plain text.
 * Only used when the MarkdownRenderer runs with `restrictSyntax`.
 */
export const DisableUnsupportedSyntaxPlugin: Plugin<[], Root> = function () {
  const data = this.data();
  data.micromarkExtensions ??= [];
  data.micromarkExtensions.push({ disable: { null: unsupportedConstructs } });
};
